import { Button, TextField, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MySnackbar from "../components/MySnackbar";
import useSnackbar from "../hooks/useSnackbar";
import { fetchRatingById, saveRatingComment } from "../http/ratingAPI";
import { RATING_ROUTE } from "../utils/consts";

const RatingDetailsPage = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [review, setReview] = useState({});

  const snack = useSnackbar(false, "Ошибка");

  useEffect(() => {
    fetchRatingById(params.id).then((data) => {
      setReview(data);
    });
  }, [params.id]);

  async function saveRating() {
    await saveRatingComment(review.id, review.adminComment);
    navigate(RATING_ROUTE);
    window.location.reload();
  }

  return (
    <Container
      sx={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
      }}
    >
      <Button
        variant="text"
        size="small"
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
        sx={{ mt: 2, mb: 1, px: 0.5, minWidth: "auto" }}
        onClick={() => navigate(-1)}
      >
        Назад
      </Button>

      <MySnackbar {...snack} />

      <Typography>
        {`Пациент: ${review.user?.name}, телефон: ${review.user?.phone} `}
      </Typography>
      <Typography>{"Оценка: " + review.rating}</Typography>
      <Typography>
        {"Отзыв (если оценка <4): " + (review.review ? review.review : "")}
      </Typography>
      <Typography>
        {`Дата отзыва: ${new Date(review.createdAt)
          .toLocaleString()
          .substring(0, 17)}`}
      </Typography>

      <Typography>{`Врач: ` + review.doctorName}</Typography>

      <TextField
        sx={{ my: 2 }}
        label="Комментарий менеджера"
        multiline
        minRows={4}
        error={!review.adminComment}
        value={review.adminComment || ""}
        onChange={(e) => {
          if (e.target.value.length > 254) {
            snack.handleChange(true, "Кол-во символов превышает 255");
          } else {
            setReview({ ...review, adminComment: e.target.value });
          }
        }}
        fullWidth
        variant="outlined"
        InputLabelProps={{ shrink: true }}
      />

      <Button
        variant="contained"
        disabled={!review.adminComment?.length > 0}
        sx={{ mb: 1 }}
        onClick={saveRating}
        disableElevation={true}
      >
        Сохранить
      </Button>
    </Container>
  );
};

export default RatingDetailsPage;
